import { __awaiter } from "tslib";
import { showAppInstallDialog, showUpgradeDialog, } from '@office-start/task-module-dialog-service';
import { getDialogType, logAppHostError } from '../utils';
export class AppInstallDialogService {
    /**
     * invoked when apps call appInstallDialog
     * @param params appId
     * @returns Promise<void>
     */
    openAppInstallDialog(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (params.appId) {
                const dialogType = yield getDialogType({ appId: params.appId });
                if (dialogType === 'UPGRADE') {
                    showUpgradeDialog === null || showUpgradeDialog === void 0 ? void 0 : showUpgradeDialog('params.appId');
                    return Promise.resolve();
                }
                showAppInstallDialog === null || showAppInstallDialog === void 0 ? void 0 : showAppInstallDialog(params.appId);
                return Promise.resolve();
            }
            logAppHostError('Open_App_Install_Dialog_Error');
            return Promise.reject();
        });
    }
}
//# sourceMappingURL=AppHostInstallDialogService.js.map